import React, { Component, PropTypes } from 'react';
import lazy from '../lib/lazy';

export default class LazyImage extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  state = {
    isVisible: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.lazyId = lazy.register(this, this.handleVisibilityChange);
    }, 100);
  }

  componentWillUnmount() {
    lazy.unregister(this.lazyId);
  }

  handleVisibilityChange(isVisible) {
    if (isVisible !== this.state.isVisible) {
      this.setState({ isVisible });
    }
  }

  render() {
    let { src, ...props } = this.props;

    if (this.state.isVisible === false) {
      src = undefined;
    }

    return (
      <img role="presentation" src={src} {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./application/js/components/LazyImage.js